import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { string, func, bool } from 'prop-types';
import React from 'react';
import { Box } from '../../atoms';
import { Label } from './seller-delivery.styles';
const partnerProps = {
  bg: '#f0f0f2',
  borderRadius: 8,
  p: 2,
  mb: 2,
  alignItems: 'center'
};

const ContentBox = _ref => {
  let {
    id,
    delivery,
    handleLabelName,
    internationalPartner,
    partnerColor
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "delivery", "handleLabelName", "internationalPartner", "partnerColor"]);

  if (!delivery && !id) return null;
  return !delivery || (id == null ? void 0 : id.toUpperCase()) === (delivery == null ? void 0 : delivery.toUpperCase()) ? /*#__PURE__*/React.createElement(Box, internationalPartner ? partnerProps : props, /*#__PURE__*/React.createElement(Label, _extends({}, internationalPartner ? {
    color: partnerColor,
    lineHeight: '16px'
  } : {}, {
    "data-testid": "label"
  }), "Vendido e entregue por ", handleLabelName(delivery))) : /*#__PURE__*/React.createElement(Box, props, /*#__PURE__*/React.createElement(Label, {
    "data-testid": "label"
  }, "Vendido por ", handleLabelName(id)), /*#__PURE__*/React.createElement(Label, {
    "data-testid": "label"
  }, "Entregue por ", handleLabelName(delivery)));
};

process.env.NODE_ENV !== "production" ? ContentBox.propTypes = {
  id: string,
  delivery: string,
  handleLabelName: func,
  internationalPartner: bool,
  partnerColor: string
} : void 0;
ContentBox.defaultProps = {
  id: 'magazineluiza',
  delivery: 'magazineluiza',
  handleLabelName: () => {},
  internationalPartner: false
};
export default ContentBox;